// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-wrapper {
  border: 1px solid black;
  border-radius: 12px;
  padding: 12px;
  height: 100px; }

.text {
  font-size: small;
  font-weight: 500; }

.borderbottom {
  border-bottom: 1px solid black; }

.round th,
.round td {
  border: 0.5px solid black;
  padding: 8px; }

.round {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate; }

.round tr:last-child td:last-child {
  border-bottom-right-radius: 10px; }

.round tr:last-child td:first-child {
  border-bottom-left-radius: 10px; }

.round tr:first-child th:first-child,
.round tr:first-child td:first-child {
  border-top-left-radius: 10px; }

.round tr:first-child th:last-child,
.round tr:first-child td:last-child {
  border-top-right-radius: 10px; }

.round {
  border-radius: var(--cui-border-radius) !important;
  overflow: hidden !important; }

.round,
th {
  font-size: small;
  font-weight: 500;
  color: black; }

.round,
td {
  height: 30px; }

.rounded {
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 16px;
  opacity: 1;
  background: transparent;
  color: #344767;
  border-radius: none;
  box-shadow: none; }

.footer {
  background-color: black;
  justify-content: center;
  align-items: center;
  display: flex;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px; }
`, "",{"version":3,"sources":["webpack://./src/components/ViewOrders/ViewOrder.scss"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa,EAAA;;AAEf;EACE,gBAAgB;EAChB,gBAAgB,EAAA;;AAElB;EACE,8BAA8B,EAAA;;AAGhC;;EAEE,yBAAyB;EACzB,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB,EAAA;;AAG3B;EACE,gCAAgC,EAAA;;AAGlC;EACE,+BAA+B,EAAA;;AAGjC;;EAEE,4BAA4B,EAAA;;AAG9B;;EAEE,6BAA6B,EAAA;;AAa/B;EACE,kDAAkD;EAClD,2BAA2B,EAAA;;AAE7B;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY,EAAA;;AAEd;;EAEE,YAAY,EAAA;;AAEd;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB,EAAA;;AAElB;EACE,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,4BAA4B,EAAA","sourcesContent":[".table-wrapper {\n  border: 1px solid black;\n  border-radius: 12px;\n  padding: 12px;\n  height: 100px;\n}\n.text {\n  font-size: small;\n  font-weight: 500;\n}\n.borderbottom {\n  border-bottom: 1px solid black;\n}\n\n.round th,\n.round td {\n  border: 0.5px solid black;\n  padding: 8px;\n}\n\n.round {\n  width: 100%;\n  border-spacing: 0;\n  border-collapse: separate;\n}\n\n.round tr:last-child td:last-child {\n  border-bottom-right-radius: 10px;\n}\n\n.round tr:last-child td:first-child {\n  border-bottom-left-radius: 10px;\n}\n\n.round tr:first-child th:first-child,\n.round tr:first-child td:first-child {\n  border-top-left-radius: 10px;\n}\n\n.round tr:first-child th:last-child,\n.round tr:first-child td:last-child {\n  border-top-right-radius: 10px;\n}\n\n// .round tr :first-child,\n// .round tr :first-child {\n//    border-left: 1px solid #000;\n//   //  border-bottom:  2px solid #000;\n// }\n// .round tr:first-child ,\n// .round tr:first-child  {\n//    border-top: 1px solid #000;\n\n// }\n.round {\n  border-radius: var(--cui-border-radius) !important;\n  overflow: hidden !important;\n}\n.round,\nth {\n  font-size: small;\n  font-weight: 500;\n  color: black;\n}\n.round,\ntd {\n  height: 30px;\n}\n.rounded {\n  padding-left: 40px;\n  padding-right: 40px;\n  margin-top: 16px;\n  opacity: 1;\n  background: transparent;\n  color: #344767;\n  border-radius: none;\n  box-shadow: none;\n}\n.footer {\n  background-color: black;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n}\n// .rounded {\n//   border-radius: 10px;\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
